export default "__VITE_ASSET__Oa7yfef___"